import * as actionTypes from '../actions/actionTypes';

const initialState = {sales: []}

const salesReducer = (state=initialState, action) => {
    switch(action.type) {
        case actionTypes.FETCH_SALES_LIST: {
            return {
                ...state,
                sales: action.sales
            }
        }
        case actionTypes.CREATE_SALE: {
            return {
                ...state,
                sales: [...state.sales, action.sale]
            }
        }
        case actionTypes.UPDATE_SALE: {
            return {
                ...state,
                sales: state.sales.map((item) => {
                    if(item.id === action.data.id) {
                        return {...action.data}
                    }
                    return item
                })
            }
        }
        case actionTypes.DELETE_SALE: {
            console.log(action)
            return {
                ...state,
                sales: state.sales.filter(sale => sale.id !== action.id)
            }
        }
        case actionTypes.CLEAR_SALE: {
            return initialState;
        }
        default: {
            return state;
        }
    }
}

export default salesReducer;